const COPY_SUFFIX_RE = / \((copy|kopia)\)$/i;

/** Replace a stored English/Swedish duplicate suffix with the current UI label. */
export function localizeDuplicateSuffix(name: string, copySuffix: string): string {
  if (!COPY_SUFFIX_RE.test(name)) return name;
  return name.replace(COPY_SUFFIX_RE, ` ${copySuffix}`);
}
